export default __webpack_public_path__ + "static/media/calculator_.fe47b42d.svg";